import MetadataDrivenContainer from './MetadataDrivenContainer';
import MetadataDrivenGroup from './MetadataDrivenGroup';
import MetadataDrivenField from './MetadataDrivenField';
import MetadataDrivenElement from './MetadataDrivenElement';

export default class MetadataDrivenParser {

    constructor(pageDefinition, viewModel) {
        this.pageDefinition = pageDefinition;
        this.viewModel = viewModel;
    }   

    parseContent(content = []) {
        const items = new Map();

        content.forEach(contentPath => {
            const leafPath = contentPath.split('.').pop();

            /*
            * The presentation metadata schema allows for 1 of 4 types. Groups, Containers, Elements, Fields.
            * The leaf element of the content path delimited by a '.' will be the metadata content type.
            * The conditional statements below check each of the content type objects from the page definition
            * to see what content type the leaf node of the content path is.
            * eg. somePage: {
            *       groups: {
            *           requiredFields: ...
            *           optionalFields: ...
            *       },
            *       fields: {
            *           firstName: ...
            *           lastName: ...
            *       }
            *     }
            *     requiredFields and optionalFields are groups and firstName and lastName are fields.
            * */
            if (this.pageDefinition.groups && this.pageDefinition.groups[leafPath]) {
                items.set(contentPath, new MetadataDrivenGroup(this.viewModel, this.pageDefinition, contentPath));
            } else if (this.pageDefinition.containers && this.pageDefinition.containers[leafPath]) {
                items.set(contentPath, new MetadataDrivenContainer(this.viewModel, this.pageDefinition, contentPath));
            } else if (this.pageDefinition.elements && this.pageDefinition.elements[leafPath]) {
                items.set(contentPath, new MetadataDrivenElement(null, this.pageDefinition, contentPath));
            } else if (this.pageDefinition.fields && this.pageDefinition.fields[leafPath]) {
                items.set(contentPath, new MetadataDrivenField(this.viewModel, this.pageDefinition, contentPath));
            } else {
                throw new Error(`Presentation Metadata does not support this contentType ${leafPath}`);
            }

        });
        return items;
    }
    
    parsePageContent() {
        this.pageDefinition.items = this.parseContent(this.pageDefinition.content);
        return this.pageDefinition;
    }
}

